import React from "react";
import { ChunkCitation } from "../../generated/core-api";
import { CitationDocItem } from "./CitationDocItem";
import styles from "./CitationView.module.css";

interface CitationOrgSectionProps {
  orgCategory: string;
  orgId: string;
  documents: {
    [docId: string]: ChunkCitation[];
  };
}

export const CitationOrgSection: React.FC<CitationOrgSectionProps> = ({
  orgCategory,
  orgId,
  documents,
}) => {
  return (
    <li className={styles.orgSection}>
      <h5 className={styles.orgHeader}>
        Knowledge Base: {orgCategory} / {orgId}
      </h5>
      <ul className={styles.orgDocumentList}>
        {Object.entries(documents).map(([docId, docCitations]) => (
          <CitationDocItem key={docId} docId={docId} citations={docCitations} />
        ))}
      </ul>
    </li>
  );
};
